module.exports = __webpack_public_path__ + "static/media/card4_10.e8288480.png";